<script>
export default {
  name: 'LampOnIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.21 6.36C18.17 4.26 16.16 2.71 13.83 2.2C11.39 1.66 8.88997 2.24 6.97997 3.78C5.05997 5.31 3.96997 7.6 3.96997 10.05C3.96997 12.64 5.51997 15.35 7.85997 16.92V17.75C7.84997 18.03 7.83997 18.46 8.17997 18.81C8.52997 19.17 9.04997 19.21 9.45997 19.21H14.59C15.13 19.21 15.54 19.06 15.82 18.78C16.2 18.39 16.19 17.89 16.18 17.62V16.92C19.28 14.83 21.23 10.42 19.21 6.36Z"
      :fill="color"
    />
    <path
      d="M15.2599 22C15.1999 22 15.1299 21.99 15.0699 21.97C13.0599 21.4 10.9499 21.4 8.93991 21.97C8.56991 22.07 8.17991 21.86 8.07991 21.49C7.96991 21.12 8.18991 20.73 8.55991 20.63C10.8199 19.99 13.1999 19.99 15.4599 20.63C15.8299 20.74 16.0499 21.12 15.9399 21.49C15.8399 21.8 15.5599 22 15.2599 22Z"
      :fill="color"
    />
  </svg>
</template>
